import LanguageEN from '@/languages/en.json';
import LanguageNO from '@/languages/no.json';
import LanguageSV from '@/languages/sv.json';

export default {
  en: LanguageEN,
  no: LanguageNO,
  sv: LanguageSV,
};
